<template>
	


		<div class="form_page valign">
			<div class="w-100">
		
			<form v-on:submit.prevent="login">


				<template v-for="error in errors">
					{{error}}
				</template>

				<router-link to="/">
					<img src="../assets/logo.png" class="logo">
				</router-link>

				<div class="form-group">
					<label>Usuario:</label>
					<input type="text" v-model="form.username" class="form-control">

				</div>

				<div class="form-group">
					<label>Contraseña:</label>
					<input type="password" v-model="form.password" class="form-control">

				</div>

				<button type="submit" class="btn btn-space btn-primary">Iniciar sesión</button>


	  			<!-- <router-link to="register" class="btn btn-space btn-secondary">Registrarme</router-link> -->
			</form>
		</div>

		</div>
</template>



<script>
import { LOGIN } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  data: function() {
    return {
      form: { username: "", password: "" }
    };
  },

  methods: {
    login: function() {
      this.$store
        .dispatch(LOGIN, this.form)
        .then(() => this.$router.push({ name: "dashboard" }))
        .catch(error => this._handleError(error));
    },

    _handleError: function(error) {
      this.form.password = "";
      this.$snotify.error(error.message);
    }
  },

  computed: {
    ...mapGetters(["errors"])
  }
};
</script>

<style lang="scss">
</style>
